import { INITIAL_RISK_FIELD_KEY, RESIDUAL_RISK_FIELD_KEY, TARGET_RISK_FIELD_KEY } from 'components/RiskMatrix';

import { EntityModules } from 'core/constants';

export type FixedSection = {
  key: string;
  title: string;
  fieldKeys: string[];
  tooltip: string;
};

// Mirrors FIXED_LAYOUT_SECTIONS in core-api's entities/standard.py, which rejects any layout that
// disagrees. Risk Scoring is fixed because a 5x5 matrix has nothing to configure.
const FIXED_SECTIONS: Partial<Record<EntityModules, FixedSection>> = {
  [EntityModules.Risks]: {
    key: 'riskScoring',
    title: 'Risk Scoring',
    fieldKeys: [INITIAL_RISK_FIELD_KEY, RESIDUAL_RISK_FIELD_KEY, TARGET_RISK_FIELD_KEY],
    tooltip:
      'Risk scores use a standard matrix. This section always sits at the bottom of the layout and its three fields cannot be changed, reordered or removed.',
  },
};

export const getFixedSection = (moduleName: string): FixedSection | undefined =>
  FIXED_SECTIONS[moduleName as EntityModules];
